'use strict';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import urljoin from 'url-join';
import { isGuid } from '../../utils/StringUtils';
import '../../theme/theme.css';
import('../../theme/css/material-icons.css');
import { Toaster } from '../../components/index';
import {
	projectsFetchData,
	projectsFetchDataByProjectCode,
	projectsFetchDataById,
} from '../../redux/actions/projects';
import { getPathwayAnimalMap, getPathwayPlantMap } from '../../redux/actions/pathwayMapData';
import { sampleSetDataFetchDataByProjectID, sampleSetFetchDataAdmin } from '../../redux/actions/sampleSetData';
import SettingsMap from '../../utils/SettingsMap';
import './ProjectContainer.scss';
import { Logger, Log } from '../../utils/Logger';
const logger = new Logger();
import * as enums from '../../enums/Enums';
import { toast } from 'react-toastify';
import { Auditor } from '@/components/util/Auditor';
import { Project } from './Project';
import { withPermissions } from '@/hooks/permissions.hook';
import * as permissions from '@/security/permissionTypes';
import { clearSelectedProjectStorage } from '@/utils/clearSelectedProjectStorage';
import { emitPortalResultsView } from '@/usageInsights/usageInsights';

export class ProjectContainer extends Auditor {

	constructor(props) {
		super(props);
		SettingsMap.initMap();
		this.state = {
			canViewProjectMilestoneDetails: true,
			projectCode: '',
			projectId: '',
			currentProjectId: '',
			displayTabs: false,
			project: {},
			sampleSets: undefined,
			showUnSavedFilesEditChanges: false,
			errormsg: '',
			isHovering: false,
			ismlimsUpdating: false,
			noAccessMessage: '',
			...super.state
		};

		this.checkUserHasPermissions = props.checkUserHasPermissions;
		this.auditLogProjectView = this.auditLogProjectView.bind(this);
		this.loadCurrentProject = this.loadCurrentProject.bind(this);
		this.setupState = this.setupState.bind(this);
	}

	componentDidMount() {
		this.loadCurrentProject();
	}

	componentDidUpdate(prevProps) {
		if (this.hasUrlParamChanged(prevProps, this.props)) {
			setTimeout(() => this.loadCurrentProject());
		}
	}

	hasUrlParamChanged(prevProps, currProps) {
		return (
			prevProps.match.params.projectCode &&
			currProps.match.params.projectCode &&
			prevProps.match.params.projectCode !== currProps.match.params.projectCode
		);
	}

	loadCurrentProject() {
		const projectRouteParam = this.props.match.params.projectCode;
		if (!projectRouteParam) {
			this.props.history.push('/home');
			return;
		}

		const fetchProjectPromise = isGuid(projectRouteParam)
			? this.props.fetchProject(projectRouteParam)
			: this.props.fetchProjectByProjectCode(projectRouteParam);

		fetchProjectPromise
			.then((result) => {
				const project = result?.response;
				if (!project?.projectId) {
					clearSelectedProjectStorage();
					this.props.history.push('/home/permissions');
					return;
				}

				if (isGuid(projectRouteParam) && project.projectCode) {
					this.props.history.replace(urljoin('/home/project', project.projectCode, 'home'));
				}

				localStorage.setItem('ProjectId', project.projectId);
				const projectsList = Array.isArray(this.props.projects) && this.props.projects.length > 0
					? this.props.projects
					: [project];
				this.setupState(project, projectsList);
			})
			.catch((error) => {
				console.error('ProjectContainer loadCurrentProject', error);
				clearSelectedProjectStorage();
				this.props.history.push('/home/permissions');
			});
	}

	setupState(project, projects) {
		this.setState({ projects: projects, project: project, projectCode: project.projectCode, projectId: project.projectId })
		//Log Project View
		this.auditLogProjectView(project.projectId);
		this.logProjectInfo(project);
		// Published delivery opened in the portal. Unpublished projects no-op.
		emitPortalResultsView(project);
		this.props.fetchSampleSetData(project.projectId).then(result => {
			let sampleSetData = result.response;
			if (sampleSetData) this.setState({ sampleSets: sampleSetData });
		}).catch();
		
		let plantReader = new FileReader(),
			animalReader = new FileReader(),
			self = this;

		plantReader.onload = () => {
			let data = JSON.parse(plantReader.result),
				map = data;
			if (map) this.setState({ plants: map });
		};

		animalReader.onload = () => {
			let data = JSON.parse(animalReader.result),
				map = data;
			if (map) this.setState({ animals: map });
		};

		self.props.fetchPlantMap().then(response => {
			self.props.fetchAnimalMap().then(response => {
				if (response) animalReader.readAsText(response);
			}).catch();
			if(response) plantReader.readAsText(response);
		});
	}

	navigateToSubView = (n) => {
		switch (n) {
			case 0:
				this.props.history.push(urljoin(this.props.match.url, 'home'));
				break;
			case 1:
				this.props.history.push(this.props.match.url + "/statstable");
				break;
			case 2:
				this.props.history.push(this.props.match.url + "/pathwayexplorer");
				break;
			default:
				this.props.history.push("");
		}
	};

	/**Logging */
	auditLogProjectView(projectId) {
		this.state.logger?.logProjectView(projectId);
	}

	logProjectInfo(project) {
		//Log subview change
		let logInfo = new Log();
		logInfo.SetLevel(enums.AppInsightLogLevel.EVENT);
		logInfo.SetName('ProjectView');
		logInfo.AddProperty('ProjectId', project.projectId);
		logInfo.AddProperty('PublishedDate', project.publishDate);
		logger.doLog(logInfo);
	}

	getProjectId() {
		if (!this.checkUserHasPermissions(permissions.CAN_EDIT_PROJECTS)) { return; }
		return <label>{this.state.project.projectId}</label>;
	}

	showToaster(title, body) {
		toast(<Toaster title={title} body={body} />);
	}

	render() {
		const { match, isLoading } = this.props;
		const { adminProjectData, errormsg, noAccessMessage, project, loading, sampleSets, sampleSetIndex, statsId, animals, plants } = this.state;

		let displayTitle = project.customerProjectTitle;
		let displayHeader = true;
		let displayProjectId = this.getProjectId();
		if (!displayTitle && project.projectTitle) {
			displayTitle = project.projectTitle.replace(project.projectCode, '');
		}

		if (adminProjectData && adminProjectData.customerProjectTitle)
			displayTitle = adminProjectData.customerProjectTitle;

		if (window.location.href.indexOf("publishingcenter") > 0) {
			displayHeader = false;
		}

		return (
			<>
				{super.render()}
				<Project
					className={this.props.className}
					match={match}
					loading={loading}
					isLoading={isLoading}
					adminProjectData={adminProjectData}
					displayHeader={displayHeader}
					displayProjectId={displayProjectId}
					displayTitle={displayTitle}
					errormsg={errormsg}
					noAccessMessage={noAccessMessage}
					project={project}
					projectCode={project.projectCode}
					projectId={project.projectId}
					showToaster={this.showToaster}
					sampleSets={sampleSets}
					sampleSetIndex={sampleSetIndex}
					statsId={statsId}
					plants={plants}
					animals={animals}
				/>
			</>
		);
	}
}

ProjectContainer.propTypes = {
	/** Project to display*/
	project: PropTypes.object,
	/** Show sidebar */
	showSideBar: PropTypes.bool,
	/** SideBar View to show */
	sideBarPage: PropTypes.number,
	/** function to hide side bar */
	onClickHideSideBar: PropTypes.func
};

ProjectContainer.defaultProps = {
	showSideBar: true,
	sideBarPage: -1,
	onClickHideSideBar: (item, e) => {

		console.log('onClickHideSideBar Click Event not defined!', item);
	}
};

const mapStateToProps = state => {
	return {
		projects: Object.values(state.projects.data),
		hasErrored: state.projects.projectsHasErrored,
		isLoading: state.projects.projectsIsLoading,
		sampleSets: state.sampleSetData.data,
		sampleSetHasErrored: state.sampleSetData.sampleSetDataHasErrored,
		sampleSetIsLoading: state.sampleSetData.sampleSetDataIsLoading,
	};
};

/* istanbul ignore next */
const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		fetchData: () => dispatch(projectsFetchData()),
		fetchDataByProjectCode: (query) => dispatch(projectsFetchData(query)),
		fetchProject: (projectId) => dispatch(projectsFetchDataById(projectId)),
		fetchProjectByProjectCode: (query) => dispatch(projectsFetchDataByProjectCode(query)),
		fetchSampleSetData: (params) => dispatch(sampleSetDataFetchDataByProjectID(params)),
		fetchPlantMap: () => dispatch(getPathwayPlantMap()),
		fetchAnimalMap: () => dispatch(getPathwayAnimalMap()),

		fetchSampleSetsDataAdmin: (params) => dispatch(sampleSetFetchDataAdmin(params)),
	};
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withPermissions(ProjectContainer)));
